import { GetterTree } from 'vuex';

import { decode } from '@/utils/custom-enc-dec';

import { FirestoreStateI } from './state';
import { RootStateI } from '../state';

export const getters: GetterTree<FirestoreStateI, RootStateI> = {
  collections: (state) => {
    if (state.collectionIds.length > 0) return state.collectionIds;
    const encodedCollections = localStorage.getItem('fscols');
    if (!encodedCollections) return state.collectionIds;
    return decode(encodedCollections).value;
  },
};
